import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/icons/crm-3.svg'
import _imports_1 from '@/assets/images/icons/crm-2.svg'
import _imports_2 from '@/assets/images/icons/crm-1.svg'


const _hoisted_1 = { class: "row justify-content-left" }
const _hoisted_2 = { class: "card border-0 box-shadow border-radius-10 mb-4" }
const _hoisted_3 = { class: "card-body p-2" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "flex-grow-1 me-3 p-3" }
const _hoisted_6 = { class: "fw-medium fs-30 mb-0" }
const _hoisted_7 = { class: "card border-0 box-shadow border-radius-10 mb-4" }
const _hoisted_8 = { class: "card-body p-2" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "flex-grow-1 me-3 p-3" }
const _hoisted_11 = { class: "fw-medium fs-30 mb-0" }
const _hoisted_12 = { class: "card border-0 box-shadow border-radius-10 mb-4" }
const _hoisted_13 = { class: "card-body p-2" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "flex-grow-1 me-3 p-3" }
const _hoisted_16 = { class: "fw-medium fs-30 mb-0" }

import { computed } from "vue"
import { useDashboardStore } from '@/stores/dashboard'
import { storeToRefs } from "pinia"
import useAuth from "@/use/useAuth"


export default /*@__PURE__*/_defineComponent({
  __name: 'DailySummary',
  setup(__props) {

const { dailyReceiptCount } = storeToRefs(useDashboardStore())
const { isSuperAdmin } = useAuth()



const columnClasses = computed(() => {
  return isSuperAdmin.value 
    ? 'col-xxl-4 col-sm-6' 
    : 'col-xxl-6 col-sm-6'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(columnClasses.value)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "fw-medium fs-18 mb-1" }, "Total Receipts", -1)),
              _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(dailyReceiptCount)?.receiptCount), 1)
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("div", { class: "crm-icon" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "crm-1"
                })
              ])
            ], -1))
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(columnClasses.value)
    }, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "fw-medium fs-18 mb-1" }, "Total Amount", -1)),
              _createElementVNode("h1", _hoisted_11, "₵" + _toDisplayString(_unref(dailyReceiptCount)?.receiptTotal.toFixed(2)), 1)
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("div", { class: "crm-icon bg-warning" }, [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: "crm-2"
                })
              ])
            ], -1))
          ])
        ])
      ])
    ], 2),
    (_unref(isSuperAdmin))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(columnClasses.value)
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "fw-medium fs-18 mb-1" }, "Total Fees", -1)),
                  _createElementVNode("h1", _hoisted_16, "₵" + _toDisplayString(_unref(dailyReceiptCount)?.receiptFees.toFixed(2)), 1)
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("div", { class: "crm-icon bg-success" }, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      alt: "crm-3"
                    })
                  ])
                ], -1))
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})